import { ref } from 'vue';
import moment from 'moment';
const DefaultFormData = {
    size: 20,
    groupTime: 10,
    similarity: 95,
};
export const useRecordForm = (query, emit) => {
    const { startTime, endTime } = query;
    const form = ref({
        ...DefaultFormData,
        snapDates: [moment().add(-7, 'd').format('yyyy-MM-DD HH:mm:ss'), moment().format('yyyy-MM-DD HH:mm:ss')],
        deviceIdList: [],
        page: 1,
    });
    const getSnapImage = () => {
        emit('updateSnapData', form.value);
    };
    const groupTimeChange = () => {
        emit('updateGroupTime', form.value);
    };
    const handleReset = () => {
        form.value = resetParams();
        getSnapImage();
    };
    const resetParams = () => {
        return {
            ...DefaultFormData,
            page: 1,
            snapDates: (startTime && endTime) ? [startTime, endTime] : [],
            deviceIdList: []
        };
    };
    return { form, getSnapImage, groupTimeChange, handleReset };
};
